import React, { Component } from "react";
import { Input, Textarea } from "../widgets/index";
import "./SupportIssueForm.css";

class SupportIssueForm extends Component {
  render() {
    return (
      <div className="create-support-ticket">
        <div className="support-ticket-form-row">
          <label className="ticket-subject">
            <span className="label-text">Subject</span>
            <div>
              <Input
                readOnly={this.props.readOnly}
                value={this.props.subject}
                onChange={e => this.props.handleFieldOnChange("subject", e.target.value)}
                error={!this.props.readOnly ? this.props.errors.subject : null}
              />
            </div>
          </label>
        </div>
        <div className="support-ticket-form-row">
          <label className="ticket-address">
            <span className="label-text">Customer Address</span>
            <div>
              <Input
                readOnly={this.props.readOnly}
                value={this.props.address}
                onChange={e => this.props.handleFieldOnChange("address", e.target.value)}
                error={!this.props.readOnly ? this.props.errors.address : null}
              />
            </div>
          </label>
        </div>
        <div className="support-ticket-form-row">
          <label className="ticket-description">
            <span className="label-text">Describe the problem</span>
            <div className="widget">
              <Textarea
                readOnly={this.props.readOnly}
                value={this.props.comment}
                onChange={e => this.props.handleFieldOnChange("comment", e.target.value)}
                error={!this.props.readOnly ? this.props.errors.comment : null}
              />
            </div>
          </label>
        </div>
      </div>
    );
  }
}

export default SupportIssueForm;
